export function getTextColorForBackground(backgroundColor: string): string {
  if (!backgroundColor || !isValidHexColor(backgroundColor)) {
    return "";
  }

  const hex = backgroundColor.replace("#", "");

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "text-default" : "text-on-primary";
}

export function isValidHexColor(color: string): boolean {
  const hexPattern = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return hexPattern.test(color);
}
